export const USER_ROLES = {
  COMMERCIAL: "commercial",
  ADMIN: "admin",
};

export const LEAD_STATUS = {
  NEW: "nouveau",
  CONTACTED: "contacté",
  QUALIFIED: "qualifié",
  NEGOTIATION: "en_négociation",
  CONVERTED: "converti",
  LOST: "perdu",
};

export const LEAD_SOURCES = [
  "Terrain",
  "Réseaux Sociaux",
  "Événement",
  "Recommandation",
  "Site Web",
  "Publicité",
  "Autre",
];

export const REVENUE_CURRENCIES = [
  { code: "EUR", label: "EUR (€)" },
  { code: "USD", label: "USD ($)" },
  { code: "FCFA", label: "FCFA (FCFA)" },
  { code: "GBP", label: "GBP (£)" },
];

export const INTERACTION_TYPES = [
  "Appel",
  "Email",
  "SMS",
  "Rencontre Physique",
  "WhatsApp",
  "Autre",
];

export const SENTIMENT_OPTIONS = [
  "Très positif",
  "Positif",
  "Neutre",
  "Négatif",
  "Très négatif",
];

export const OBSERVATION_LEVELS = [
  { value: "info", label: "Information" },
  { value: "success", label: "Félicitations" },
  { value: "warning", label: "Avertissement" },
  { value: "danger", label: "Critique" },
];
